import { I as t } from "../../iconLoader.gen-BMhf6Txz.js";
function o(r) {
  return typeof r == "string" && r in t;
}
export {
  o as isIconName
};
